import { StateMachine } from "./StateMachine";
import ConsoleUtil from '../utils/ConsoleUtil';
import App from "../App";
import GameEvents from "../const/GameEvents";
import GameModel from "../model/GameModel";

/**
 * Abstraction that initiates game state logic and chains to the next state when completed.
 */
export abstract class State {
    public name: string;
    protected exitLinkId: number;
    protected links: ILink[];
    protected exitLink: ILink;
    protected stateMachine: StateMachine;
    protected chainSkipping: boolean;

    protected timer: number;

    constructor(stateMachine: StateMachine) {
        this.stateMachine = stateMachine;
        this.chainSkipping = false;
    }

    public enter(): void {
        /**
         * Override method to add custom state logic
         * and run Exit when state should move to next one
         */
        this.timer = new Date().getTime();

        this.stateMachine.currentState = this;
        // this.exit();
    }

    public canExit(): boolean {
        /**
         * Override method to alow externel skip of state
         */
        return false;
    }

    public skip() {
        this.exit();
    }

    private canChainExit(): boolean {
        if (this.canExit()) {
            this.exitLinkId = 0;
            let link = this.getNextLink();
            while (link && !link.condition.check()) {
                link = this.getNextLink();
            }
            return link.next.canExit();
        }

        return false;
    }

    public setChainSkipping() {
        this.chainSkipping = this.canChainExit();
    }

    public chainSkip() {
        this.setChainSkipping();

        if (this.canExit()) {
            this.skip();
        }
    }

    public exit(): void {
        this.exitLinkId = 0;
        let link = this.getNextLink();
        while (link && !link.condition.check()) {
            link = this.getNextLink();
        }
        if (!link) {
            throw new Error("Missing valid state link");
        }

        this.exitLink = link;

        this.onComplete();
    }

    protected onComplete(): void {
        if (this.stateMachine.currentState === this) {
            if (!GameModel.gameConfig.debugLogging || GameModel.gameConfig.debugLogging.states === true) {
                ConsoleUtil.logWithColor(
                    "[State] EXIT state: " +
                        this.name +
                        " [" +
                        (new Date().getTime() - this.timer) / 1000 +
                        " sec]",
                    0xd17783
                );
                // this.stateMachine.currentState = this.exitLink.next;
                ConsoleUtil.logWithColor(
                    "[State] ENTER state: " + this.exitLink.next.name,
                    0xa3d177
                );
    
                ConsoleUtil.logWithColor(
                    "[State] chain skipping: " + this.chainSkipping,
                    0x9dbbe3
                    );
                }

            App.dispatcher.emit(GameEvents.STATE_CHANGED, this.exitLink.next.name, this.name);
            let chaining = this.chainSkipping;
            this.chainSkipping = false;

            if (chaining) {
                this.exitLink.next.setChainSkipping();
            }

            this.exitLink.next.enter();

            if (chaining) {
                this.exitLink.next.chainSkip();
            }
        } else {
            this.chainSkipping = false;
        }
    }

    error(): void {
        throw new Error("ERRROR");
    }

    addLink(link: ILink): void {
        if (!this.links) {
            this.links = [];
        }

        this.links.push(link);
    }

    getNextLink(): ILink {
        const link = this.links[this.exitLinkId];
        this.exitLinkId++;
        return link;
    }
}

export interface ILink {
  condition: ICondition;
  next: State;
}

export interface ICondition {
  check: () => boolean;
}

export interface IStatesConfigSchema {
  entryPoint: string;
  states: IStateConfig[];
  condition: IConnectionConfig[];
}

export interface IStateConfig {
  name: string;
  links: ILinkConfig[];
}

interface ILinkConfig {
  condition: string;
  nextState: string;
}

interface IConnectionConfig {
  name: string;
}
